import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="mono-label" data-testid="auth-loading">Attending…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
